import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';

/** Native modal <dialog>: focus trapping, Escape to close and a backdrop come from the browser. */
export function Dialog({ open, onClose, title, children, testId }: { open: boolean; onClose: () => void; title: string; children: ReactNode; testId?: string }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    if (!open && d.open) d.close();
  }, [open]);
  return (
    <dialog
      ref={ref}
      className="dialog"
      aria-labelledby={testId ? `${testId}-title` : undefined}
      onClose={onClose}
      onClick={(e) => {
        if (e.target === ref.current) onClose();
      }}
      data-testid={testId}
    >
      {open ? (
        <>
          <div className="dialog-head">
            <h2 id={testId ? `${testId}-title` : undefined}>{title}</h2>
            <button type="button" className="btn btn-quiet btn-sm" onClick={onClose} aria-label="Close">
              ✕ Close
            </button>
          </div>
          <div className="dialog-body">{children}</div>
        </>
      ) : null}
    </dialog>
  );
}
